import { render, staticRenderFns } from "./SaleSampleList.vue?vue&type=template&id=6024cdb6&scoped=true"
import script from "./SaleSampleList.vue?vue&type=script&lang=js"
export * from "./SaleSampleList.vue?vue&type=script&lang=js"
import style0 from "./SaleSampleList.vue?vue&type=style&index=0&id=6024cdb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6024cdb6",
  null
  
)

export default component.exports